const getters = {
  // 生成有权限的数组
  authItem(state) {
    let JGList = JSON.parse(JSON.stringify(state.leftList))
    let fundsLeft = JGList[3]
    let newFundLeft = []
    if (!fundsLeft) return
    for (let item of fundsLeft.children) {
      for (let authItem of state.fundsAuth) {
        let label = authItem.pageName
        if (label === '充值码支付') {
          label = '商城支付'
        }
        //&&!(authItem.isFirst=='0' && authItem.pageName=='网上支付')
        if (new RegExp(label).test(item.meta.title) && authItem.pageStatus === "0" && ((authItem.isFirst=='1' && authItem.isFirstStatus=='0')||(authItem.isFirst=='0' && authItem.notFirstStatus=='0'))) {
          newFundLeft.push(item.meta.title)
        }
      }
      if (item.meta.title === '提现' || item.meta.title === '资金明细' ) {
        newFundLeft.push(item.meta.title)
      }
    }
    return newFundLeft
  },
  // 左侧
  currenLeftList(state) {
    let JGList = JSON.parse(JSON.stringify(state.leftList))

    if (state.listType != 0) {
      if (state.userRole != '2') {
        JGList[1] = ''
      }
      // 已经升级账户 不显示升级入口
      // if (state.userRole != '4') {
      //   JGList[6] = ''
      // }

      // 不是直客则不显示首充活动  是直客则不显示原油
      if (state.userRole != '4' && state.userRole != '5') {
        JGList[7] = ''
      } else {
        JGList[5].children.splice(1, 1)
      }
      return JGList
    } else {
      let newList = []
      state.leftList.forEach((item, index) => {
        if (index == 0 || index == 2 || index == 3) {
          newList.push(item)
        } else {
          newList.push('')
        }
      });
      return newList
    }
  }
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js